"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPageOriginUrl = exports.genNonce = exports.buildOauthLogoutUrl = exports.buildOauthLoginUrl = void 0;
const store2_1 = __importDefault(require("store2"));
const qs = __importStar(require("@zipit/ls-core-sdk/dist/querystring"));
const models_1 = require("./models");
const buildOauthLoginUrl = ({ url, clientId, scope, identityProvider, flow }) => {
    const nonce = (0, exports.genNonce)();
    // set values so that we can reassociate this request when we come back
    store2_1.default.set('lsAuthNonce', nonce);
    store2_1.default.set('lsOauthFlow', flow);
    // TODO - figure out if there is a better way to specify scope that is not cognito specific
    let params = Object.assign({ response_type: flow, client_id: clientId, state: nonce, redirect_uri: (0, exports.getPageOriginUrl)() }, (identityProvider ? { identity_provider: identityProvider } : {}));
    const hostedLoginUrl = `${url}?${qs.stringify(params)}&scope=${scope}`;
    return hostedLoginUrl;
};
exports.buildOauthLoginUrl = buildOauthLoginUrl;
const buildOauthLogoutUrl = ({ url, clientId, logoutRedirect }) => {
    const logoutEndpoint = url.replace('/login', '/logout').replace('/oauth2/authorize', '/logout');
    const logoutUrl = `${logoutEndpoint}?client_id=${clientId}&logout_uri=${logoutRedirect || (0, exports.getPageOriginUrl)()}`;
    return logoutUrl;
};
exports.buildOauthLogoutUrl = buildOauthLogoutUrl;
const genNonce = () => {
    // in IE window.crypto is experimental and prefixed
    const browserCrypto = window.crypto || window['msCrypto'];
    // from SO: https://stackoverflow.com/questions/10051494/oauth-nonce-value
    const charset = '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz-._~';
    const randomValues = Array.prototype.slice.call(browserCrypto.getRandomValues(new Uint8Array(32)));
    const charsetValues = randomValues.map(num => charset[num % charset.length]).join('');
    return charsetValues;
};
exports.genNonce = genNonce;
const getPageOriginUrl = () => {
    if (!window.location.origin) {
        const { protocol, hostname, port } = window.location;
        return `${protocol}//${hostname}${port ? `:${port}` : ''}${models_1.PORTAL_ROUTE}`;
    }
    return `${window.location.origin}${models_1.PORTAL_ROUTE}`;
};
exports.getPageOriginUrl = getPageOriginUrl;
//# sourceMappingURL=utils.js.map